import { converterDataEua, converterDataHoraBr } from "_utils/Data";
import { utils, writeFileXLSX } from "xlsx";
import {
  chaveStatusAutorizacao,
  chaveStatusProducao,
  labelStatus,
} from "../constants/status";
import { IItemExportacaoLote } from "../interfaces/IItemExportacaoLote";
import { rotuloPrensa } from "./rotulosLote";

export const COLUNAS_EXPORTACAO_LOTES = [
  "Lote",
  "Data e hora da solicitação",
  "PDI",
  "Prensa",
  "Empresa",
  "Placa",
  "Processo",
  "Autorização",
  "Status autorização",
  "Status produção",
  "Observação",
];

export type IPlacaExportacao = Omit<IItemExportacaoLote, "idLote">;

export interface IChavesStatus {
  autorizacao: (codigo: number) => string;
  producao: (codigo: number) => string;
}

const CHAVES_STATUS_GENERICAS: IChavesStatus = {
  autorizacao: chaveStatusAutorizacao,
  producao: chaveStatusProducao,
};

export function linhasExportacaoLotes(itens: IItemExportacaoLote[]) {
  return itens.map((item) => ({
    Lote: item.idLote,
    ...linhaExportacaoPlaca(item),
  }));
}

export function linhaExportacaoPlaca(
  item: IPlacaExportacao,
  chaves: IChavesStatus = CHAVES_STATUS_GENERICAS
) {
  return {
    "Data e hora da solicitação":
      converterDataHoraBr(item.dataSolicitacao) ?? "",
    PDI: item.pdi ?? "",
    Prensa: item.prensa === null ? "" : rotuloPrensa(item.prensa),
    Empresa: item.empresa ?? "",
    Placa: item.placa,
    Processo: item.idProcesso ?? "",
    Autorização: item.idAutorizacao ?? "",
    "Status autorização": labelStatus(
      chaves.autorizacao(item.statusAutorizacao)
    ),
    "Status produção":
      item.statusProducao === null
        ? ""
        : labelStatus(chaves.producao(item.statusProducao)),
    Observação: item.observacao ?? "",
  };
}

export function exportarLotesXlsx(
  itens: IItemExportacaoLote[],
  hoje: Date = new Date()
) {
  const planilha = utils.json_to_sheet(linhasExportacaoLotes(itens), {
    header: [...COLUNAS_EXPORTACAO_LOTES],
  });
  const arquivo = utils.book_new();

  utils.book_append_sheet(arquivo, planilha, "Lotes");
  writeFileXLSX(arquivo, `lotes_placa_${converterDataEua(hoje)}.xlsx`);
}
